import ChooseFraction from "../../components/ClassOne/Mathematics/ChooseFraction";
import FractionWordProblems from "../../components/ClassOne/Mathematics/FractionWordProblems";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/fraction/choose-correct", title: "Choose Correct", component: ChooseFraction },
    { url: "/class-one/mathematics/fraction/word-problem", title: "Word Problem", component: FractionWordProblems },
];

export default topics;